export const ARIA_LABEL_ID = 'rename-session';
export const EDIT_SESSION_POPUP_SHOW_INFO_MESSAGE = 'edit-session-popup-show-info-message';
